import React from "react";
import { TransactionDetailsFooterProps } from "../../../types/components";
import { ICONS, TRANSFER_METHODS, TRANSACTION_TYPES } from "../../../constants/enums";
import { GetApiReceiptData } from "../../../api/general";
import { DisclaimerType } from "../../../types/api/moneyTransfer";
import useErrorModal from "../../../hooks/useErrorModal";
import { ACTION_DISPLAY_TYPES } from "../../../constants/enums";

import PickupInstructions from "../../MoneyTransfer/PickupInstructions";
import ActionLink from "../../Common/ActionLink";
import Icon from "../../Common/Icon";
import Action from "../../Common/Action";

const TransactionDetailsFooter = ({ transactionDetails, transferId, transactionType, rrTransferMethod, setButtonLoading }: TransactionDetailsFooterProps) => {
  const openErrorModal = useErrorModal();

  /**
   * Get the filename for the receipt based on the transfer method
   * @param transferMethod
   */
  const getRRReceiptFilename = (transferMethod?: string) => {
    let filename: string;

    switch (transferMethod) {
      case TRANSFER_METHODS.PUSH_TO_CARD:
        filename = `Brightwell_Send_To_Debit_Card_${transferId}.pdf`
        break;
      case TRANSFER_METHODS.TO_ACCOUNT:
        filename = `Send_With_Brightwell_${transferId}.pdf`
        break;
      case TRANSFER_METHODS.MOBILE_WALLET:
        filename = `Brightwell_Mobile_Wallet_${transferId}.pdf`
        break;
      default:
        filename = `Brightwell_Transfer_${transferId}.pdf`;
    }

    return filename;
  }

  /**
     * Get Receipt from API 
     */
  const handleGetReceipt = async () => {
    const downloadReceiptUrl = transactionDetails?.downloadReceiptUrl;
    if (!downloadReceiptUrl) return;

    setButtonLoading(true);
    let filename: string;
    let referenceNumber = transactionDetails?.referenceNumberField?.formattedValue;
    if (transactionDetails?.moneyTransferId) {
      const serviceTypeString = transactionType === TRANSACTION_TYPES.MONEY_TRANSFER ? "CashPickup" : "SendToAccount";
      filename = `Brightwell_${serviceTypeString}_${referenceNumber}.pdf`;
    } else {
      filename = getRRReceiptFilename(rrTransferMethod);
    }

    try {
      await GetApiReceiptData(downloadReceiptUrl, filename);
      setButtonLoading(false);
    } catch (err) {
      openErrorModal(err);
      setButtonLoading(false);
    };
  }

  /**
   * Build the disclaimers to display
   * @param {*} disclaimers
   */
  const renderDisclaimers = (disclaimers: DisclaimerType[]) => {
    if (disclaimers && disclaimers.length) {
      return disclaimers.map((d) => {
        return (
          <p key={d.disclaimerId} className="x-small disclaimer">
            <sup>{d.disclaimerId} </sup>
            {d.text}
          </p>
        );
      });
    }
  }

  return (
    <>
      {transactionDetails?.disclaimers &&
        renderDisclaimers(transactionDetails.disclaimers)
      }

      {transactionDetails?.downloadReceiptUrl &&
        <div className={`flex-row align-items-top ${transactionDetails?.pickupInstructions ? "justify-content-between" : "justify-content-end"}`}>

          {transactionDetails?.pickupInstructions &&
            <PickupInstructions instructions={transactionDetails.pickupInstructions} className="col-flex-3" />
          }

          <div className={`flex-row justify-content-end${transactionDetails?.pickupInstructions ? "col-flex-2" : "col-flex-1"}`}>
            <Action
              onClick={() => handleGetReceipt()}
              className="bold"
              displayType={ACTION_DISPLAY_TYPES.TEXT}
              title={transactionDetails.downloadReceiptText}
              isReceipt={true}
            />
          </div>
        </div>
      }

      {transactionDetails?.footerContent &&
        <div dangerouslySetInnerHTML={{ __html: transactionDetails.footerContent }} />
      }
    </>
  );
}

export default TransactionDetailsFooter;